import React from "react";
import { NavItem, NavbarBrand } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { Button, BaseHeader, PhoneIcon, Logo } from "@jobmatchme/ui";
import styles from "./style.module.scss";

const Header = () => (
  <div className={styles.navWrapper}>
    <BaseHeader
      nav={
        <NavItem>
          <a href="/de/fahrer">
            <Button size="small" variant="text" color="white">
              <FormattedMessage
                id="app.common.header.bc.c2a"
                defaultMessage="Als LKW-Fahrer bewerben"
              />
            </Button>
          </a>
          <a href="/de/arbeitgeber">
            <Button size="small" variant="text" color="white">
              <FormattedMessage
                id="app.common.header.pc.crosslink"
                defaultMessage="LKW-Fahrer suchen"
              />
            </Button>
          </a>
        </NavItem>
      }
      phone={
        <Button
          size="small"
          external
          link="tel:+494022860090"
          variant="text"
          color="white"
        >
          <PhoneIcon className={styles.phoneIcon} alt="phone" />{" "}
          <span>+49 40 22 86 00 90</span>
        </Button>
      }
      callToAction={" "}
      mobileNav={
        <>
          <a href="/de/fahrer">
            <Button variant="outlined" color="white" size="medium" fullWidth>
              <FormattedMessage
                id="app.common.header.bc.mobile.crosslink"
                defaultMessage="Job als LKW Fahrer finden"
              />
            </Button>
          </a>
          <a href="/de/arbeitgeber">
            <Button color="white" variant="outlined" size="medium" fullWidth>
              <FormattedMessage
                id="app.common.header.bc.mobile.register"
                description="Link text for base header goto bc "
                defaultMessage="LKW-Fahrer finden"
              />
            </Button>
          </a>
          <Button
            link="tel:+494022860090"
            variant="text"
            color="white"
            size="medium"
            fullWidth
            external
          >
            <PhoneIcon className={styles.phoneIcon} alt="Telefon" /> +49 40 22
            86 00 90
          </Button>
        </>
      }
    >
      <NavbarBrand className={styles.brand} href="/de/">
        <Logo variant="light" globalThemeVariant="pc" size="small" />
      </NavbarBrand>
    </BaseHeader>
  </div>
);

export default Header;
